import { render, staticRenderFns } from "./recutSummaryWidget.vue?vue&type=template&id=325d0e26&"
import script from "./recutSummaryWidget.vue?vue&type=script&lang=js&"
export * from "./recutSummaryWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports